import { useCallback } from 'react';

import { printDocumentAsPdf } from '@dreryk/react-common';
import { ActionBar, ButtonVariant, componentsTranslationKeys } from '@dreryk/react-components';

import { DocumentTemplateFormController } from '~libs.desktop.shared.document-template';

import { usePushBackToVisit } from '../../../shared/hooks/usePushBackToVisit';
import { translationKeys } from '../translations';

import { VisitConsentApproveActionInterceptor } from './interceptors/VisitConsentApproveActionInterceptor';
import { VisitConsentApproveOnSuccessCallback } from './interceptors/VisitConsentApproveActionInterceptor.types';

type VisitConsentApproveAndPrintActionProps = Pick<DocumentTemplateFormController, 'handleSubmit' | 'markPristine'> & {
   readonly patientId: number;
   readonly printTemplateId: number;
   readonly visitId: number;
};

export const VisitConsentApproveAndPrintAction = (props: VisitConsentApproveAndPrintActionProps): JSX.Element => {
   const pushBackToVisit = usePushBackToVisit(props.visitId);
   const handleSuccess = useCallback<VisitConsentApproveOnSuccessCallback>(async ({ documentFile }) => {
      await printDocumentAsPdf({ base64: documentFile.data });
   }, []);

   return (
      <VisitConsentApproveActionInterceptor
         patientId={props.patientId}
         visitId={props.visitId}
         printTemplateId={props.printTemplateId}
         handleSubmit={props.handleSubmit}
         markPristine={props.markPristine}
         onSuccess={handleSuccess}
      >
         <ActionBar.PrimaryButton
            variant={ButtonVariant.PRIMARY}
            onClick={pushBackToVisit}
            label={translationKeys.confirmAndPrint}
            testId={'confirmAndPrint'}
            blockingOperation={componentsTranslationKeys.savingData}
         />
      </VisitConsentApproveActionInterceptor>
   );
};
